
        import * as module0 from './json_diff_controller.js';import * as module1 from './rules_config_controller.js';import * as module2 from './rules_grid_controller.js'
        export default [module0.default,module1.default,module2.default];
        export const context = {
          'json_diff_controller.js': module0.default,'rules_config_controller.js': module1.default,'rules_grid_controller.js': module2.default
        }
      